import Http from '@/utils/request';

export default {
  // 授权
  grantSubject: (data) => Http.post('/api/v1/licenses/grant', data)
};
